import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import Vue from 'vue';
import atom from '@tencent/vft-atom';
import openApp from '@tencent/vft-common/openapp/openapp-account-check';
import { loginService, userService, vipService } from '@vip-activity/business';
import util from '@tencent/vft-common/util';
import { buildUrl } from '@tencent/vft-common/url';
import { defaultAvatar } from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { fixShareConfig } from '@/util/helper';
import _reportData from '@/config/reportData';
import store from '@/store';
Vue.mixin({
  data: function data() {
    return {
      loginService: loginService,
      userService: userService,
      vipService: vipService,
      defaultAvatar: defaultAvatar
    };
  },
  filters: {
    hideNick: util.hideNick,
    formatNum: util.formatNum
  },
  computed: {
    userAvatar: function userAvatar() {
      return this.userService && this.userService.headurl || defaultAvatar;
    },
    rootShareConfig: function rootShareConfig() {
      var config = window.setting.默认分享;
      return fixShareConfig(config, {
        user: userService || {}
      });
    },
    reportData: function reportData() {
      return _reportData;
    },
    isLiveEnd: function isLiveEnd() {
      return store.getters.isLiveEnd;
    },
    selfTicketCount: function selfTicketCount() {
      return store.getters.selfTicketCount;
    },
    hasTicket: function hasTicket() {
      return store.state.hasZhiboTicket || store.state.hasDianboTicket;
    }
  },
  methods: {
    loginTips: function loginTips() {
      var _this = this;

      this.confirm({
        msg: '当前登录态已过期，请重新登录',
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _this.$openLogin();
        }
      });
    },
    isSchema: function isSchema() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return url.match(/^(txvideo|tenvideo2)/);
    },
    openUrl: function openUrl(url) {
      if (!url) {
        return;
      }

      if (this.isSchema(url)) {
        openApp.openApp(url);
      } else {
        atom.openUrl(url);
      }
    },
    openProperty: function openProperty() {
      this.openUrl('//film.qq.com/weixin/v3/asset/index.html?header=0#award');
    },
    openKefu: function openKefu() {
      this.openUrl('//kf.qq.com/touch/video/index.html');
    },
    openVip: function openVip() {
      if (!this.loginService.isLogin) {
        this.$openLogin();
        return;
      }

      var url = window.setting.告别时刻.开通会员.跳转链接;
      var curUrl = window.location.href;
      url = buildUrl(url, {
        ru: encodeURIComponent(curUrl)
      });
      this.openUrl(url);
    }
  }
});